<template>
<div>
	<modal-dialog
		:modal-visible="visible"
		title="Select a Template"
		:submit-visible="false"
		modal-size="modal-lg"
		v-on:closeModal="$emit('closeModal')">

		<field 
			class="mb-2"
			:params="{
				type: 'btn-group',
				buttons: [
					{text: 'Search',icon:'fa-search',value:'search'},
					{text: 'Browse',icon:'fa-tags',value:'browse'}
			]}"
			v-model="findType">
		</field>

		<categorized-list-record-selector
			:is-customer-asset-template="true"
			:type="findType"
			v-on:select="selectTemplate">
		</categorized-list-record-selector>

	</modal-dialog>

</div>
</template>
<script type="text/javascript">

import ModalDialog from "@/components/ModalDialog"
import Field from "@/components/Field"
import CategorizedListRecordSelector from "@/components/super_components/CategorizedListRecordSelector"

export default {
	components: {
		ModalDialog,
		Field,
		CategorizedListRecordSelector,
	},
	props: [
		"visible"
	],
	data() {
		return {
			findType: 'browse'
		}
	},
	methods: {
		selectTemplate(template) {
			this.$emit("addTemplate", template)
		},
		mutateTemplates(templates) {
			return templates.map(template => {
				template.parentCategoryName = template.CustomerAssetCategory.name
				return template
			})
		}
	},
	created() {

	}
}
</script>